// @core/api/endpoints/team/get_team_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamBannerResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get team banner
 * Retrieves the team's banner image URL and metadata.
 */
export async function GetTeamBanner(
  team_id: string,
  options?: RequestOptions
): Promise<GetTeamBannerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/banner`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<GetTeamBannerResponse>(requestPath, { ...requestOptions });
}
